import { sortMembersByType } from '@atlassian/teams-client';
import { type TeamMembership, type TeamWithImageUrls } from '@atlassian/teams-client/types';

import type { TeamAppState as TeamState } from '../../types';

export const joinTeamState = (teamState: TeamState, newMembership: TeamMembership): TeamState => {
	const { exitedTeams, teamMembers, teamProfile } = teamState;

	const requestingToJoin = newMembership.state === 'REQUESTING_TO_JOIN';

	const teamId = newMembership.membershipId.teamId;

	if (requestingToJoin) {
		return {
			...teamState,
			myTeamMembership: {
				teamId,
				hasLoaded: true,
				membership: newMembership,
			},
		};
	}

	// If we're joining this team, remove it from the set of exited teams
	exitedTeams.delete(teamId);

	const currentUserId = newMembership.membershipId.memberId;

	const newMembers = teamMembers.members
		.filter((membership) => {
			return membership.membershipId.memberId !== currentUserId;
		})
		.concat(newMembership);

	return {
		...teamState,
		teamProfile: {
			teamId,
			hasLoaded: true,
			isLoading: false,
			errorType: null,
			data: {
				...(teamProfile.data as TeamWithImageUrls),
				permission: 'FULL_WRITE',
			},
		},
		teamMembers: {
			teamId,
			hasLoaded: true,
			hasError: false,
			isLoading: false,
			isLoadingNextPage: false,
			errorType: null,
			members: sortMembersByType(newMembers, currentUserId),
			requestingToJoinUsers: teamMembers.requestingToJoinUsers,
			membersPageInfo: teamMembers.membersPageInfo,
			requestingToJoinUsersPageInfo: { hasNextPage: false, cursor: null },
		},
		myTeamMembership: {
			teamId,
			hasLoaded: true,
			membership: newMembership,
		},
	};
};
